import {Component} from "@angular/core";

@Component({
  selector: 'fabric8-configmaps-list-toolbar',
  templateUrl: './list-toolbar.configmap.component.html',
  styleUrls: ['./list-toolbar.configmap.component.scss'],
})
export class ConfigMapsListToolbarComponent {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
